// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RelatedPapersSidebar-cls1___03d1935136c33b53296{/*!*/}.RelatedPapersSidebar-cls2__ab38ea72894eeaf48d7f{padding-top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RelatedPapersSidebar-cls1___03d1935136c33b53296",
	"cls2": "RelatedPapersSidebar-cls2__ab38ea72894eeaf48d7f RelatedPapersSidebar-cls1___03d1935136c33b53296"
};
export default ___CSS_LOADER_EXPORT___;
